import { publicApiClient } from './publicClient.js';

// Generic public entity API class (no authentication required)
class PublicEntityAPI {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }

  // List entities with filtering and pagination
  async list(params = {}) {
    console.log(`[Public API] Calling list for ${this.endpoint}`, params);
    return publicApiClient.get(`/public/${this.endpoint}`, params);
  }

  // Filter entities with specific criteria
  async filter(criteria = {}) {
    return publicApiClient.get(`/public/${this.endpoint}`, criteria);
  }

  // Get entity by ID
  async getById(id) {
    return publicApiClient.get(`/public/${this.endpoint}/${id}`);
  }
}

// Public Book entity
export const PublicBook = new PublicEntityAPI('books');

// Public Product entity
export const PublicProduct = new PublicEntityAPI('products');

// Public Book Edition entity
export const PublicBookEdition = new PublicEntityAPI('book-editions');

// Public Product Component entity
export const PublicProductComponent = new PublicEntityAPI('product-components');

// Public App Settings entity
export const PublicAppSettings = new PublicEntityAPI('app-settings');

// Public Inventory Movement entity
export const PublicInventoryMovement = new PublicEntityAPI('inventory-movements');

// Public Stock Balance entity
export const PublicStockBalance = new PublicEntityAPI('stock-balances');

// Public Promo Group entity
export const PublicPromoGroup = new PublicEntityAPI('promo-groups');

// Public Items entity (new universal system)
export const PublicItems = new PublicEntityAPI('items');

// Public Checkout entity (centralized checkout service)
export const PublicCheckout = {
  // Create order using checkout service
  async createOrder(data) {
    return publicApiClient.post('/checkout/orders', data);
  },

  // Get order details using checkout service
  async getOrderById(id) {
    return publicApiClient.get(`/checkout/orders/${id}`);
  },

  // Initiate payment using checkout service
  async initiatePayment(orderId, paymentMethod) {
    return publicApiClient.post('/checkout/payments/initiate', { 
      orderId, 
      paymentMethod 
    });
  },

  // Get shipping offers using checkout service
  async getShippingOffers(data) {
    return publicApiClient.post('/checkout/shipments/offers', data);
  },

  // Get Metaship widget key using checkout service
  async getMetashipWidgetKey() {
    return publicApiClient.get('/checkout/shipments/widget-key');
  },

  // T-Bank payment methods
  async initiateTBankPayment(orderId) {
    return publicApiClient.post('/checkout/payments/initiate', { 
      orderId, 
      paymentMethod: 'tbank' 
    });
  },

  async getTBankPaymentStatus(orderId) {
    return publicApiClient.getNoCache(`/checkout/orders/${orderId}/payments/tbank/status`);
  },
};

// Public Waitlist entity
export const PublicWaitlist = {
  // Add to waitlist (public endpoint, no authentication required)
  async create(waitlistData) {
    return publicApiClient.post('/public/waitlist', waitlistData);
  },
};

// Public Target Map entity
export const PublicTargetMap = {
  async getAddressesByCode(code) {
    return publicApiClient.getNoCache(`/public/target-groups/${code}/addresses`);
  },
};

// Public Consent subsystem
export const PublicConsent = {
  // Список текущих версий документов; типы — массив (eula, privacy_policy, ...)
  async getCurrent(types) {
    const qs = Array.isArray(types) && types.length
      ? `?types=${encodeURIComponent(types.join(','))}`
      : '';
    return publicApiClient.get(`/public/consent-docs/current${qs}`);
  },
  // Получить конкретную версию по ID (включая архивные)
  async getById(id) {
    return publicApiClient.get(`/public/consent-docs/${id}`);
  },
  // Standalone-сабмит согласия (для форм без других сущностей)
  async submit(payload) {
    return publicApiClient.post('/public/consents', payload);
  },
};
